import { http } from '@/utils/http.util';

export default class pageTypeService {
   async getPageTypes() {
      return await http.get('/api/page-type').then((response) => {
         return response.data;
      });
   }
}
